import { render, staticRenderFns } from "./ModalIntegrarRepasses.vue?vue&type=template&id=d72be97e"
import script from "./ModalIntegrarRepasses.vue?vue&type=script&lang=ts"
export * from "./ModalIntegrarRepasses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports